/* eslint-disable no-unused-vars */
const data2 = [
  {
    alias: "streamline",
    title: "Streamline",
    subtitle:
      "Video Streaming Platform that Consolidates Content from all other Streaming Apps",
    role: "Solo Brand/UX/UI Designer",
    targAud: "Anyone who uses video streaming apps",
    duration: "January 2023 - May 2023",
    tag: [
      "branding",
      "ux/ui design",
      "figma",
      "typography",
      "user research",
      "product design",
    ],
    links: [
      {
        link: "https://www.figma.com/proto/5URMsR0axp6YLlhlDWs1OR/UX23-app-design_04-25?page-id=140%3A2090&type=design&node-id=277-9307&viewport=149%2C238%2C0.02&t=IXxZuPkYUEBst0FL-1&scaling=contain&starting-point-node-id=277%3A9307&mode=design",
        linkDescription: "Streamline Project Presentation",
      },
      {
        link: "https://www.figma.com/proto/5URMsR0axp6YLlhlDWs1OR/UX23-app-design_04-25?page-id=15%3A24&type=design&node-id=15-27&viewport=371%2C422%2C0.12&t=CUBxmzjErS8rANJQ-1&scaling=scale-down&starting-point-node-id=127%3A2287&mode=design",
        linkDescription: "Streamline Prototype",
      },
    ],
    splashImg:
      "https://davyjonesdesign.github.io/data-for-axios/assets/streamline/UX23-streamline-splash.png",
    ovCont: [
      "I find it hard to remember which apps have the content I want to watch, leading me to pay for movies that I already have access to on other platforms and I know at least 20 people who face the same problem. My idea was to create a new streaming platform that consolidates the content of all other streaming apps. With this, users can easily search and stream content from all synced apps in one place. The aim is to save users time by eliminating the need to switch between apps, making it easier to find and watch content.",
    ],
    ovProto:
      "https://mega.nz/embed/z4BjDSLD#yRTNLpaXoSzr1T7_2NYmzfD1ig4FLa-nq08aWlRh_Do",
    ovImgDes: "Streamline Streaming App UX Design Presentation",
    goalCont: [
      "The goal of this project was to allow insights into user behavior and preferences on video streaming apps to inform the design of a new app that consolidates multiple streaming services.",
    ],
    goalImg:
      "https://davyjonesdesign.github.io/data-for-axios/assets/streamline/UX23-streamline-splash.png",
    goalImgDes: "Streamline Splash Screen",
    approachCont: [
      "I conducted a survey with 20 participants to understand their streaming app usage. User personas guided the design process, resulting in wireframes and a first prototype. Feedback led to a second prototype with improved UI.",
    ],
    approachImg:
      "https://davyjonesdesign.github.io/data-for-axios/assets/streamline/UX23-streamline-sketches.png",
    approachImgDes: "Initial Streamline App Sketches",
    ocCont: [
      "Future work may include research, focusing on a single scenario, and responsive design for larger screens. User testing will continue with a wider audience. Development process details were not provided.",
    ],
    ocProto:
      "https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Fproto%2F5URMsR0axp6YLlhlDWs1OR%2FUX23-app-design_04-25%3Fpage-id%3D15%253A24%26type%3Ddesign%26node-id%3D15-27%26viewport%3D371%252C422%252C0.12%26t%3DCUBxmzjErS8rANJQ-1%26scaling%3Dcontain%26starting-point-node-id%3D127%253A2287%26mode%3Ddesign",
    ocImgDes: "Prototype Iteration #2",
  },
  {
    alias: "airbnb",
    title: "Airbnb",
    subtitle: "Bible Study Web App Designed and Developed with Vue Framework",
    role: "Solo Brand/UX/UI Designer and Developer",
    targAud: "Older women in their sixties",
    duration: "August 2021 - December 2021",
    tag: ["branding", "ux/ui design", "figma"],
    links: [
      {
        link: "https://www.figma.com/proto/bLww2BBvNUsjAAZbIOgu4w/airbnb-redesign?node-id=317%3A1614&scaling=scale-down&page-id=0%3A1&starting-point-node-id=317%3A1614&hide-ui=1",
        linkDescription: "Figma Design System",
      },
      {
        link: "https://www.figma.com/proto/74IM7vTuezwu4BEJlcWk3L/12.3-desktop-prototype?node-id=1%3A19&scaling=scale-down&page-id=0%3A1&starting-point-node-id=1%3A19&hide-ui=1",
        linkDescription: "Desktop Prototype",
      }
    ],
    splashImg:
      "https://davyjonesdesign.github.io/data-for-axios/assets/airbnb/airbnb-mockup.jpg",
    ovCont: [
      "Airbnb is a well-known online marketplace that allows individuals to rent out their properties or spare rooms to travelers. The platform has primarily focused on a younger demographic, but there is an opportunity to expand its customer base by targeting older women in their sixties.",
    ],
    ovProto:
      "https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Fproto%2FbLww2BBvNUsjAAZbIOgu4w%2Fairbnb-redesign%3Fnode-id%3D317%253A1591%26starting-point-node-id%3D317%253A1591%26scaling%3Dscale-down-width",
    ovImgDes: "Figma Airbnb Overview",
    goalCont: [
      "The goal of the redesign is to update Airbnb's UX/UI design to better cater to the needs and preferences of older women in their sixties, and to expand the company's customer base by attracting and retaining this demographic.",
    ],
    goalProto:
      "https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Fproto%2FpP3gPoziHkUfTXNzMu8Cmr%2F6.3-updated-brand-style-guide_v3%3Fnode-id%3D2%253A3%26scaling%3Dscale-down-width%26page-id%3D0%253A1%26starting-point-node-id%3D2%253A3",
    goalImgDes: "Figma Airbnb Brand Style Guide",
    approachCont: [
      "To achieve the goal of the redesign, the approach was focused on prioritizing ease of use and accessibility. The design reflected a mature and sophisticated look and feel, using a color palette and typography that conveys comfort and reliability.",
    ],
    approachProto:
      "https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Fproto%2FbLww2BBvNUsjAAZbIOgu4w%2Fairbnb-redesign%3Fnode-id%3D317%253A1614%26scaling%3Dscale-down-width%26page-id%3D0%253A1%26starting-point-node-id%3D317%253A1614embed",
    approachImgDes: "Figma Airbnb Design System",
    keyfeatCont: [
      "Large, easy-to-read text",
      "Clean and simple layout",
      "Clear calls to action",
      "Detailed information about properties and their surroundings, including safety features and nearby amenities",
      "Intuitive search function",
    ],
    ocCont: [
      "The outcome of the UX/UI redesign for Airbnb is expected to be a welcoming and reliable experience for older women in their sixties, leading to an expansion of the company's customer base. By prioritizing ease of use, accessibility, and a mature and sophisticated look and feel, Airbnb will be well-positioned to attract and retain older women as customers.",
    ],
    ocProto:
      "https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Fproto%2F74IM7vTuezwu4BEJlcWk3L%2F12.3-desktop-prototype%3Fnode-id%3D1%253A19%26scaling%3Dscale-down-width%26page-id%3D0%253A1%26starting-point-node-id%3D1%253A19",
    ocImgDes: "Figma Airbnb Desktop Prototype",
  },
  {
    alias: "watermark",
    title: "Watermark",
    subtitle: "Bible Study Web App Designed and Developed with Vue Framework",
    role: "Solo Brand/UX/UI Designer and Developer",
    targAud: "Pastors, Bible Scholars, and people interested in Bible study",
    duration: "May 2021 - December 2021",
    tag: ["branding", "ux/ui design", "dev/programming", "vue"],
    links: [
      {
        link: "https://www.watermarkstudies.com/",
        linkDescription: "Live Watermark Website",
      },
    ],
    splashImg:
      "https://davyjonesdesign.github.io/data-for-axios/assets/watermark/watermark-mockup.jpg",
    ovCont: [
      "In today's digital age, technology has revolutionized the way people interact with the Bible and how they study it. To support this trend, I designed and developed a Bible study web app using the Vue framework.",
    ],
    ovImg:
      "https://davyjonesdesign.github.io/data-for-axios/assets/watermark/home.jpg",
    ovImgDes: "Watermark - Home Page",
    goalCont: [
      "The goal of this project was to create a user-friendly platform that would allow users to easily access and find relevent Bible studies in a visually appealing and intuitive way. Additionally, the app had to be optimized for mobile devices and provide a seamless user experience on all screen sizes.",
    ],
    goalImg:
      "https://davyjonesdesign.github.io/data-for-axios/assets/watermark/study.jpg",
    goalImgDes: "Watermark Study Page",
    approachCont: [
      "To meet the challenge, I utilized the Vue framework, which provides a highly efficient and intuitive way to build dynamic user interfaces. The Vue framework allowed me to build a scalable and performant app that provided a seamless user experience on all devices.",
    ],
    approachImg:
      "https://davyjonesdesign.github.io/data-for-axios/assets/watermark/study-resource.jpg",
    approachImgDes: "Watermark Study Page - Resources Section",
    keyfeatCont: [
      "Searchable Bible Study Database",
      "Linked Resources",
      "Optimized fo the Web Bible Study Pages",
    ],
    ocCont: [
      "Since its launch, the Bible study web app has been well-received by users. The searchable Bible study cards, full study pages and cited resources links have proven to be popular features and have helped users engage with the Bible on a deeper level. The responsive design has also made it easy for users to access the app on the go, further increasing its usability.",
      "The Bible study web app is a prime example of how technology can be used to enhance the experience of studying the Bible. By utilizing the Vue framework and designing a user-friendly platform, users are able to interact with the Bible in a more meaningful and impactful way. The app's success serves as a testament to the potential of technology to enhance our spiritual journeys.",
    ],
    ocImg:
      "https://davyjonesdesign.github.io/data-for-axios/assets/watermark/resources.jpg",
    ocImgDes: "Watermark Resources Page",
  },
  {
    alias: "forward",
    title: "Forward Creative Agency",
    subtitle:
      "A full brand and website design for an industrial marketing agency",
    role: "Lead Brand & UX/UI Designer",
    targAud: "Large Industrial Businesses",
    duration: "April 2019 - April 2020",
    tag: ["branding", "ux/ui design"],
    splashImg:
      "https://davyjonesdesign.github.io/data-for-axios/assets/fwd/forward-splash.jpg",
    ovCont: [
      "Forward Marketing began with a redesign of its entire branding and website with the vision of becoming the next biggest marketing agency in the industrial market. I and two other members of our team embarked on a research journey to discover how we could best provide the appropriate solutions.",
    ],
    ovImg:
      "https://davyjonesdesign.github.io/data-for-axios/assets/fwd/fwd-home_thumb.jpg",
    ovImgDes: "Forward Home Page - Landing",
    goalCont: [
      "The goal of this particular project was to initiate a market-leading brand and website that would meet the growing need for marketing in the industrial space. All signs pointed to our need to create a brand and website that would point out our experiences and proven methods of increasing organic traffic.",
    ],
    goalImg:
      "https://davyjonesdesign.github.io/data-for-axios/assets/fwd/fwd-home.jpg",
    goalImgDes: "Forward Home Page - What We Do",
    approachCont: [
      "We discovered that industrial companies are looking for companies to work with that are reputable, cost-effective, and fully invested in their interests. I hypothesized that if I could style our brand and web content that would speak directly to these felt needs, we would be able to hit the ground running.",
    ],
    approachImg:
      "https://davyjonesdesign.github.io/data-for-axios/assets/fwd/fwd-about.jpg",
    approachImgDes: "Forward About Page - Meet the Crew",
    ocCont: [
      " We developed a brand and website that was well-recieved by industrial business leaders and would have been a real contender in their market. Unofrtunately, due to COVID-19, the project was abandoned before we could launch. But I believe Forward would have been successful if it had not been for unforseen circumstances.",
    ],
    ocImg:
      "https://davyjonesdesign.github.io/data-for-axios/assets/fwd/fwd-blog-single.jpg",
    ocImgDes: "Forward Blog Page - Single",
  },
  {
    alias: "sanlo",
    title: "Sanlo Inc.",
    subtitle:
      "A full rebrand and website redesign for an industrial cable manufacturing company",
    role: "Lead Brand & UX/UI Designer",
    targAud:
      "Large Industrial Companies with a Need for Industrial Cable Assemblies and Extrusion",
    duration: "April 2019 - November 2019",
    tag: ["branding", "ux/ui design"],
    splashImg:
      "https://davyjonesdesign.github.io/data-for-axios/assets/sanlo/sanlo-mockup-23.jpg",
    ovCont: [
      "Engineered cable assemblies and extrusion manufacturing is a complex industry that requires a well-designed website to effectively communicate the products and services offered.",
    ],
    ovImg:
      "https://davyjonesdesign.github.io/data-for-axios/assets/sanlo/home.jpg",
    ovImgDes: "Sanlo Home Page - Landing",
    goalCont: [
      "The main challenge was to design a website that would effectively communicate the company's expertise and capabilities in the industry while providing a user-friendly experience. Additionally, the website needed to be visually appealing and reflect the company's brand identity.",
    ],
    goalImg:
      "https://davyjonesdesign.github.io/data-for-axios/assets/sanlo/icons-contact.jpg",
    goalImgDes: "Sanlo Home Page - Service Icon Section",
    approachCont: [
      "To meet the challenge, a comprehensive UX/UI/Brand design process was implemented. This process involved extensive research on the target audience, competitive analysis, and creation of wireframes and prototypes. User testing was also conducted to refine the design and ensure that it met the needs of the target audience.",
      "A consistent brand identity was developed, including the logo, color palette, typography, and imagery, to ensure a cohesive look and feel throughout the website.",
    ],
    approachImg:
      "https://davyjonesdesign.github.io/data-for-axios/assets/sanlo/form.jpg",
    approachImgDes: "Sanlo - Custom Quote Form Tool",
    ocCont: [
      "The UX/UI/Brand design of the engineered cable assemblies and extrusion manufacturer website was a success in meeting the needs of the target audience and effectively communicating the company's expertise and capabilities. The comprehensive design process and attention to detail have resulted in a user-friendly, visually appealing website that accurately reflects the company's brand identity and has had a positive impact on the company's bottom line.",
    ],
    ocImg:
      "https://davyjonesdesign.github.io/data-for-axios/assets/sanlo/blog.jpg",
    ocImgDes: "Sanlo Blog Page",
  },
  {
    alias: "cwi",
    title: "Central Wire Industries",
    subtitle:
      "A full rebrand and website redesign for an industrial wire manufacturing company",
    role: "Lead Brand & UX/UI Designer",
    targAud: "Large Industrial Companies with a Need for Industrial Wire",
    duration: "April 2019 - November 2019",
    tag: ["branding", "ux/ui design"],
    splashImg:
      "https://davyjonesdesign.github.io/data-for-axios/assets/cwi-web-mockups.jpg",
    ovCont: [
      "Central Wire Industries was looking to reestablish themselves as the premiere wire manufacturer on the continent. I and two other members of our team embarked on a research journey to discover how we could best provide the appropriate solutions.",
    ],
    ovImg:
      "https://davyjonesdesign.github.io/data-for-axios/assets/cwi-web-mockups-assets/cwi-home-top.jpg",
    ovImgDes: "CWI Home Page - Landing",
    goalCont: [
      "The goal of this project was to reimagine Central Wire's brand and redesign their website in way that positioned them to compete with elite industrial brands and optimized conversion rates.",
    ],
    goalImg:
      "https://davyjonesdesign.github.io/data-for-axios/assets/cwi-web-mockups-assets/cwi-home-3.jpg",
    goalImgDes: "CWI Home Page - Global Reach Section",
    approachCont: [
      "After reconciling leadership's vision and customer feedback, we set out to design a brand and website that was simple, bold and foundational along with an easy-to-use website with highly interactive product pages that would provide seemless lead generation.",
    ],
    approachImg:
      "https://davyjonesdesign.github.io/data-for-axios/assets/cwi-web-mockups-assets/cwi-product.jpg",
    approachImgDes: "CWI - Product Page",
    ocCont: [
      "We developed a brand and website that was well-recieved by CWI's leadership and customers alike. After launching, CWI's revenue saw a massive increase in online leads and subsequent sales. The new brand established CWI as a strong and sturdy manufacturer within their market and continues to grow in value.",
    ],
    ocImg:
      "https://davyjonesdesign.github.io/data-for-axios/assets/cwi-web-mockups-assets/cwi-man-cap.jpg",
    ocImgDes: "CWI - Manufacturing Capabilities",
  },
  {
    alias: "stem",
    title: "STEM Search Group",
    subtitle: "A branding project for for a recruiting firm",
    role: "Lead Brand Designer",
    targAud: "People in STEM Fields",
    duration: "Summer 2020",
    tag: ["branding"],
    splashImg:
      "https://davyjonesdesign.github.io/data-for-axios/assets/stem/stem__mockup--snapback.jpg",
    ovCont: [
      "In 2020, STEM Search Group was looking to break open into the STEM jobsearch and recruiting market. I was hired by their web developer to develop a brand for them that would help them do this.",
    ],
    ovImg:
      "https://davyjonesdesign.github.io/data-for-axios/assets/stem/stem-brand.jpg",
    ovImgDes: "STEM - Logo",
    goalCont: [
      "The goal of this project was to develop a brand for a recruiting firm that would establish them as a leader in the STEM market.",
    ],
    goalImg:
      "https://davyjonesdesign.github.io/data-for-axios/assets/stem/stem__mockup--facebookpage.jpg",
    goalImgDes: "STEM - Facebook Mockup",
    approachCont: [
      "After meeting with leadership and gathering intel on their market and postion, I set out to design a brand that was future-oriented, engaging, and set them ahead of the pack.",
    ],
    approachImg:
      "https://davyjonesdesign.github.io/data-for-axios/assets/stem/stem__mockup--linkedinpage.jpg",
    approachImgDes: "STEM — Linkedin Page",
    ocCont: [
      "The final brand and brand assets were well-recieved by STEM's leadership. After launching, they saw a massive growth and continue to be a major leader in their region as the leading recruiting firm.",
    ],
    ocImg:
      "https://davyjonesdesign.github.io/data-for-axios/assets/stem/stem__mockup--shirt.jpg",
    ocImgDes: "STEM - Shirt Mockup",
  },
  {
    alias: "Caps",
    title: "Caps",
    subtitle: "The Trusted Mushroom Magazine",
    role: "Lead Designer",
    targAud: "People who are into Foraging",
    duration: "Winter 2022",
    tag: ["branding", "typography", "digital illustration", "print"],
    splashImg:
      "https://davyjonesdesign.github.io/data-for-axios/assets/caps-magazine/magazine-mockup.jpg",
    ovCont: [
      "For my final project in a Master's Typography course, I was tasked with designing a magazine from scratch.",
    ],
    ovProto:
      "https://indd.adobe.com/embed/85283b4a-ccfd-4901-81c5-e139d23fa37f?startpage=1&allowFullscreen=true",
    ovImgDes: "Caps Mushroom Magazine - Digital Version",
    goalCont: [
      "The goal of this project was to design a premium, earthy and vintage magazine featuring all things mushrooms to be published on a quarterly basis for amatuer to seasoned mushroom enthusiasts in all parts of the US.",
    ],
    goalImg:
      "https://davyjonesdesign.github.io/data-for-axios/assets/caps-magazine/magazine-styleguide.jpg",
    goalImgDes: "Caps Mushroom Magazine - Style Guide",
    approachCont: [
      "I started by creating a moodboard where I compiled a few visual and contextual touchpoints I wanted to keep in scope. After iterating out a masthead, I then began developing the front cover, table of contents, centerspread, and style guide.",
    ],
    approachImg:
      "https://davyjonesdesign.github.io/data-for-axios/assets/caps-magazine/magazine-moodboard.png",
    approachImgDes: "Caps Mushroom Magazine - Moodboard",
    ocCont: [
      "After many round of peer reviews, I finalized all assets and mocked up a printed version. The magazine brand and layout exceeded expections, meeting my initial desires for the magazine to feel natural, earthy and whimsical with a flavor of vintage.",
    ],
    ocImg:
      "https://davyjonesdesign.github.io/data-for-axios/assets/caps-magazine/magazine-centerspread.jpg",
    ocImgDes: "Caps Mushroom Magazine - Centerspread",
  },
];

export default data2;
